import SFGiveAuthorization from './SFGiveAuthorization'
export default SFGiveAuthorization
